import ProductCostDistribution from './ProductCostDistribution'

export default ProductCostDistribution
